<template>
    <div class="text-center">
        <v-dialog width="600" v-model="dialog">
            <template v-slot:activator="{ on }">
                <v-btn small outlined elevation="0" text v-on="on">
                    Изменить<v-icon  color="grey" right small>mdi-tune-variant</v-icon>
                </v-btn>
            </template>
            <v-card class="px-3 py-5">
                <v-card-title class="headline" primary-title
                    >Настройки профиля {{ profile.fullName }}
                </v-card-title>
                <v-card-text>
                    <v-switch
                        label="Заблокировать для регистрации"
                        @click="changeDisable()"
                        v-model="disabledStatus"
                    ></v-switch>
                    <div>
                        <v-switch
                        label="Регистрация в резервный список"
                        @click="changeReserve()"
                        v-model="reserveStatus"
                    ></v-switch>
                    </div>
                    <div class="mt-3">
                        <div class="text--primary">
                            Количество мест для регистрации:
                        </div>
                    </div>
                    <div
                        class="d-flex align-center increaseSlots"
                    >
                        <v-text-field v-model="newQuantity" hide-details single-line type="number" />
                        <v-btn color="primary" elevation="0" small @click="changeMaxQuantity()">Изменить</v-btn>
                    </div>
                    
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data: function() {
        return {
            id: this.profile._id,
            dialog: false,
            quantity: this.profile.quantity,
            newQuantity: this.profile.quantity,
            reserveStatus: this.profile.reserve,
            disabledStatus: this.profile.disabled
        }
    },
    props: ['profile'],
    methods: {
        async changeDisable() {
            const { data } = await this.$axios
                .post('/api/block-profile/', {
                    _id: this.id,
                    disabled: this.disabledStatus,
                })
                if(data.answer = "success") {
                this.$notify({
                    text: data.msg
                });
            } else {
                this.$notify({
                    type: 'error',
                    text: 'Произошла ошибка'
                });
            }
        },
        async changeReserve() {
            const { data } = await axios.post('/api/reserve-profile/', {
                _id: this.id,
                reserve: this.reserveStatus,
            })
            if(data.answer = "success") {
                this.$notify({
                    text: data.msg
                });
            } else {
                this.$notify({
                    type: 'error',
                    text: 'Произошла ошибка'
                });
            }
        },
        async changeMaxQuantity() {
            // if (this.newQuantity <= this.quantity) {
            //     return this.$notify({
            //         type: 'error',
            //         text: 'Нельзя указать меньше текущего значения'
            //     })
            // }
            try {
                await axios.post('/api/max-quantity-profile/', {
                    _id: this.id,
                    quantity: this.newQuantity
                })
                this.$notify({
                    text: 'Профиль изменен'
                });
                this.quantity = this.newQuantity
            } catch (error) {
                console.log(error);
                this.$notify({
                    type: 'error',
                    text: 'Произошла ошибка'
                })
            }
        }

    }
}
</script>
<style>
.increaseSlots .v-text-field {
    margin-top: 0;
    padding-top: 0;
}
.increaseSlots button {
      margin-left: 20px;
}
</style>